import React from "react";
import styles from "./SponsoredPartners.module.css";
import redgear from "../../../assets/images/robotics/sponsers/img11.jpg";
import urban from "../../../assets/images/robotics/sponsers/img12.jpg";
import educationKnot from "../../../assets/images/robotics/sponsers/img13.jpg";
import STEMx from "../../../assets/images/robotics/sponsers/img14.jpg";
import youngHustlers from "../../../assets/images/robotics/sponsers/img15.jpg";
import MichiTech from "../../../assets/images/robotics/sponsers/img16.jpg";

const SponsoredPartners = () => {
  const partners = [
    redgear,
    urban,
    educationKnot,
    STEMx,
    youngHustlers,
    MichiTech,
  ];

  return (
    <section className={styles.sponsoredPartners}>
      <div className={styles.container}>
        <h2 data-aos="fade-up">Our Sponsored Partners</h2>
        <div className={styles.grid}>
          {partners.map((partner, index) => (
            <div key={index} className={styles.partner}>
              <img src={partner} alt={`Partner ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SponsoredPartners;
